
import { defineComponent, reactive, ref, UnwrapRef } from "vue";
import { LoginRequest, loginValidateRule, postLogin } from "@/api/login";
import useVuelidate from "@vuelidate/core";
import axios from "axios";
import { ErrorResponse } from "common/src/utils/request";
import { setErrorMessage } from "common/src/utils/validate";
import router from "@/router";
import constants from "common/src/constants";
import { MutationTypes, useStore } from "@/store";
import { getMe } from "common/src/api/me";

/**
 * 画面ID: SCR200
 * 画面内容: ログイン画面
 */
export default defineComponent({
  setup() {
    // フォーム変数作成
    const loginForm: UnwrapRef<LoginRequest> = reactive({
      userId: "",
      password: "",
      authType: "",
    });

    // 全体エラーメッセージ
    const g$: string[] = reactive([]);

    // フィールドエラーを外部からセットする変数
    const $externalResults = ref({});
    // フィールドエラー設定初期化
    const f$ = useVuelidate(loginValidateRule, loginForm, {
      $autoDirty: true,
      $externalResults,
    });

    const store = useStore();

    const login = async () => {
      // 外部フィールドエラーリセット
      f$.value.$clearExternalResults();
      // 全体エラーリセット
      g$.splice(0, g$.length);
      f$.value.$touch();
      if (f$.value.$invalid) return;

      try {
        // API0010(ログイン)呼び出し
        const res = await postLogin(loginForm);

        // トークンをセッションストレージへ格納
        // トークンは共通処理で使用する関係で直接セッションストレージを使用
        window.sessionStorage.setItem(constants.ACCESS_TOKEN_KEY_MYPAGE, res.data.accessToken);
        window.sessionStorage.setItem(constants.REFRESH_TOKEN_KEY_MYPAGE, res.data.refreshToken);

        // API0040(認証者情報取得)呼び出し
        const me = await getMe();

        // 認証者情報をストアへ格納
        store.commit(MutationTypes.SET_ME, me.data);
        router.push({ name: "Top" });
      } catch (err) {
        if (axios.isAxiosError(err) && (err.response?.status === 400 || err.response?.status === 403)) {
          setErrorMessage(g$, $externalResults, err.response?.data as ErrorResponse);
        }

        // 利用者情報取得APIでエラーが出ることを考慮しトークンをセッションストレージから削除
        window.sessionStorage.removeItem(constants.ACCESS_TOKEN_KEY_MYPAGE);
        window.sessionStorage.removeItem(constants.REFRESH_TOKEN_KEY_MYPAGE);
      }
    };

    return {
      loginForm,
      login,
      f$,
      g$,
    };
  },
});
